import cn from 'classnames';
import { Form, Field, FieldArray, ErrorMessage, getIn } from 'formik';

import Button from 'components/common/Button';
import styles from 'styles/components/signUpFunnel/thankYou/InviteForm';

const InviteForm = ({ touched, values }) => {
  return (
    <Form aria-label="invite form">
      <FieldArray
        name="invitations"
        render={() => (
          <div className="flex justify-center">
            <div className="text-center">
              {values.invitations.map((email, index) => (
                <div key={index}>
                  <label htmlFor={`invitations[${index}].email`} hidden>
                    Email a friend
                  </label>
                  <Field
                    name={`invitations[${index}].email`}
                    placeholder="Email a friend"
                    className={cn(styles.emailInput, styles.smartphoneEmailBox, 'textMd mt-2')}
                  />
                  {getIn(touched, `invitations[${index}].email`) && (
                    <ErrorMessage
                      name={`invitations[${index}].email`}
                      render={msg => <p className="errorMessage">{msg}</p>}
                    />
                  )}
                </div>
              ))}
            </div>
            <div className="mt-2">
              <Button
                type="submit"
                className={cn(
                  styles.smartphoneSend,
                  'flex items-center justify-center rounded-l-none disabled:opacity-50'
                )}
              >
                Send
              </Button>
            </div>
          </div>
        )}
      />
    </Form>
  );
};

InviteForm.propTypes = {
  touched: PropTypes.object,
  values: PropTypes.object,
};

export default InviteForm;
